import React from "react";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

export type LoadingOverlayProps = {
  /** true の間、全画面オーバーレイとスピナーを表示する */
  open: boolean;
  /** スピナー下に表示する文言（既定: "読み込み中..."） */
  message?: string;
};

/**
 * 全画面ローディングオーバーレイ（共通コンポーネント）。
 *
 * API レスポンス待ちなど、処理完了まで操作をブロックして待機させたい場面で利用する。
 * 背後のクリックを遮り、スピナーと文言でユーザーに進行中であることを伝える。
 *
 * 例:
 *   - ログイン中（Cloud Run のコールドスタート待ち）: `<LoadingOverlay open message="ログイン中..." />`
 *   - データ保存中 / 読み込み中 など今後の各画面でも再利用する想定。
 */
export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  open,
  message = "読み込み中...",
}) => {
  return (
    <Backdrop
      open={open}
      role="status"
      aria-live="polite"
      sx={{
        color: "#fff",
        display: "flex",
        flexDirection: "column",
        gap: 2,
        // ダイアログ等よりも前面に出してログイン画面全体を覆う
        zIndex: (theme) => theme.zIndex.modal + 1,
      }}
    >
      <CircularProgress color="inherit" aria-hidden />
      <Typography component="div" sx={{ fontSize: "18px", fontWeight: "bold" }}>
        {message}
      </Typography>
    </Backdrop>
  );
};
